import React, {useEffect, useState} from "react";
import {Spinner} from "react-bootstrap";
import InstallService from "../../services/install.service";

function TransferSubscriptionModal({ show, customerId, onCancelClick, deviceIdToTransfer, transferDeviceId, deviceMacIds }) {
    
    const [isMounted, setIsMounted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    const [transferredToMacId, setTransferredToMacId] = useState(null);
    const [installList, setInstallList] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    
    useEffect(() => {
        setIsMounted(true);

        return () => {
            setIsMounted(false);
        }
    }, []);
    
    useEffect(() => {
        if (isMounted && show && customerId) {
            loadData();
        }
    }, [show]);
    
    const loadData = () => {
        setIsLoading(true);

        const isProCustomer = isNaN(parseInt(customerId));

        if (isProCustomer && deviceMacIds && deviceMacIds.length > 0) {
            // Pro customer: fetch installs for each known MAC in parallel
            Promise.all(
                deviceMacIds.map(mac =>
                    InstallService.getinstallbymacid(mac).catch(() => null)
                )
            ).then(results => {
                const seen = new Set();
                const condensedList = results
                    .filter(r => r != null && r.macId)
                    .filter(install => {
                        if (seen.has(install.macId)) return false;
                        seen.add(install.macId);
                        return true;
                    });

                const filteredList = condensedList.filter(
                    i => i.macId?.toLowerCase() !== deviceIdToTransfer?.toLowerCase()
                );

                if (filteredList.length === 0) {
                    InstallService.getreplacementinstallsbymacaddress(deviceIdToTransfer).then(response => {
                        setTransferredToMacId(response?.data?.length > 0 ? response.data[0].macId : null);
                        setInstallList([]);
                        setIsLoading(false);
                    }).catch(() => { setTransferredToMacId(null); setIsLoading(false); });
                } else {
                    setInstallList(filteredList);
                    setTransferredToMacId(null);
                    setIsLoading(false);
                }
            }).catch(e => {
                console.error(e);
                setTransferredToMacId(null);
                setIsLoading(false);
            });
            return;
        }

        // Legacy: fetch all installs by TT customer org ID
        InstallService.getinstallsbycustomerorgid(customerId).then((response) => {
            if (response && response.data && response.data.length > 0) {
                const condensedList = [];
                const seen = new Set();

                response.data.sort((a, b) => new Date(b.endDateTime) - new Date(a.endDateTime))
                    .forEach(item => {
                        if (!seen.has(item.macId)) {
                            condensedList.push(item);
                            seen.add(item.macId);
                        }
                    });

                const filteredList = condensedList.filter(i => i.macId.toLowerCase() !== deviceIdToTransfer.toLowerCase());

                // If there are no mac ids to transfer the subscription to, query for replacements to see if it has already been transferred
                if (filteredList.length === 0) {
                    InstallService.getreplacementinstallsbymacaddress(deviceIdToTransfer).then((response) => {
                        if (response && response.data && response.data.length > 0) {
                            setTransferredToMacId(response.data[0].macId);
                        } else {
                            setTransferredToMacId(null);
                        }
                        
                        setInstallList([]);
                        setIsLoading(false);
                    }).catch((e) => {
                        console.error(e);
                        setTransferredToMacId(null);
                        setIsLoading(false);
                    });
                } else {
                    setInstallList(filteredList);
                    setTransferredToMacId(null);
                    setIsLoading(false);   
                }
            } else {
                setInstallList([]);
                setTransferredToMacId(null);
                setIsLoading(false);
            }
        }).catch((e) => {
            console.error(e);
            setTransferredToMacId(null);
            setIsLoading(false);
        });
    }
    
    const handleTransferDeviceId = () => {
        if (selectedOption != null) {
            transferDeviceId(selectedOption, deviceIdToTransfer);
        }
    }
    
    const renderContent = () => {
        return transferredToMacId ? <label htmlFor="description"><b>This device has already been transferred to device ID {transferredToMacId}.</b></label> : installList?.length === 0 ? <label htmlFor="description"><b>This device cannot be transferred.</b></label> : <div>
            <label htmlFor="description"><b>Select the Device ID to transfer this subscription to:</b></label>

            {installList?.length > 0 ? installList?.map((option) => (
                <label key={option.id} className="d-block">
                    <input
                        type="radio"
                        className="margin-right-5"
                        checked={selectedOption === option}
                        onChange={() => setSelectedOption(option)}
                    />
                    {option.macId.toUpperCase()}
                </label>
            )) : null}
        </div>
    }
    
    return (
        <div className="modal" style={{display: show ? "block" : "none"}}>
            <div className="modal-wrapper"
                 style={{
                     transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                     opacity: show ? '1' : '0'
                 }}>

                <div className="modal-header">
                    <h3>Transfer Subscription</h3>

                    <span className="close-modal-btn" onClick={e => {
                        onCancelClick();
                    }}>×</span>
                </div>

                <div className="modal-body">
                    {isLoading ?
                        <div className='centered' style={{ minHeight: '300px', alignItems: 'center' }}><Spinner animation="border" variant="dark" /></div>
                        : renderContent()
                    }
                </div>

                <div className="modal-footer" style={{position: 'sticky', bottom:0}}>
                    <button className="secondary-btn btn-small" onClick={e => {
                        onCancelClick();
                    }}>Close
                    </button>
                    <button className="primary-btn btn-small" onClick={handleTransferDeviceId}>Transfer Subscription</button>
                </div>
            </div>
        </div>
    );
}

export default TransferSubscriptionModal;